import { render, staticRenderFns } from "./Herbarium.vue?vue&type=template&id=24014e7c&scoped=true&"
import script from "./Herbarium.vue?vue&type=script&lang=js&"
export * from "./Herbarium.vue?vue&type=script&lang=js&"
import style0 from "./Herbarium.vue?vue&type=style&index=0&id=24014e7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24014e7c",
  null
  
)

export default component.exports